jQuery(function($){
    const mobileBreakpoint = 1000;

    $("#mobile-menu-open").on("click", function(){
        $("#header-nav .nav").toggleClass("active");
    });

    $(document).on("click", "#mobile-menu-close", function(e){
        e.preventDefault();
        $("#header-nav .nav").removeClass("active");
    });

    // Menü dışına tıklayınca kapatma
    $(document).on("click", function(e){
        if($(window).width() > mobileBreakpoint) return;
        if(
            !$(e.target).closest("#header-nav .nav").length &&
            !$(e.target).closest("#mobile-menu-open").length
        ) {
            $("#header-nav .nav").removeClass("active");
        }
    });

    // Mobil Alt Menü Aç/Kapat (Sadece mobilde çalışır)
    $(document).on('click', '#header-menu .menu-item-has-children > a', function(e) {
        if ($(window).width() > mobileBreakpoint) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        var $parent = $(this).parent();
        var $submenu = $parent.children('.sub-menu');
        var isCurrentlyOpen = $parent.hasClass('open');
        
        // Diğer tüm açık alt menüleri kapat
        $('#header-menu .menu-item-has-children').not($parent).removeClass('open');
        $('#header-menu .sub-menu').not($submenu).css({
            'display': 'none',
            'opacity': '0',
            'visibility': 'hidden',
            'transform': 'translateY(10px)',
            'max-height': '0'
        });
        
        // Seçileni aç/kapat toggle yap
        if (!isCurrentlyOpen) {
            $parent.addClass('open');
            $submenu.css({
                'display': 'block',
                'opacity': '1',
                'visibility': 'visible',
                'transform': 'translateY(0)',
                'max-height': '500px'
            });
        } else {
            $parent.removeClass('open');
            $submenu.css({
                'display': 'none',
                'opacity': '0',
                'visibility': 'hidden',
                'transform': 'translateY(10px)',
                'max-height': '0'
            });
        }
    });

    // Mobilde aktif menünün alt menüsünü otomatik aç
    if ($(window).width() <= mobileBreakpoint) {
        $('#header-menu .current-menu-parent, #header-menu .current-menu-ancestor')
            .addClass('open')
            .children('.sub-menu')
            .css({
                display: 'block',
                opacity: '1',
                visibility: 'visible',
                transform: 'translateY(0)',
                maxHeight: '500px'
            });
    }

    /* SCROLL SMALL - BIGG */
    jQuery(window).scroll(function () {
        if(jQuery(window).scrollTop() >= jQuery("#header").height() + 10) {
            jQuery("#header").addClass("small")
            jQuery("#header").removeClass("big")
        } else {
            jQuery("#header").addClass("big")
            jQuery("#header").removeClass("small")
        }
    })
});